import { FC } from 'react';
import { Button, ModalInfo, ModalInfoProps } from '@/components';
import styles from './ConfirmActionModal.module.sass';

interface ConfirmActionModalProps extends ModalInfoProps {
  onConfirm: () => void;
  confirmButtonText: string;
  cancelButtonText: string;
}

const ConfirmActionModal: FC<ConfirmActionModalProps> = (props) => {
  const {
    title,
    isOpen,
    onClose,
    onConfirm,
    confirmButtonText,
    cancelButtonText,
    children,
  } = props;

  return (
    <ModalInfo isOpen={isOpen} title={title} onClose={onClose}>
      <div className={styles.message}>{children}</div>
      <div className={styles.actions}>
        <Button type="secondary" corner="rect" onClick={onClose}>
          {cancelButtonText}
        </Button>
        <Button type="orange" corner="rect" onClick={onConfirm}>
          {confirmButtonText}
        </Button>
      </div>
    </ModalInfo>
  );
};

export default ConfirmActionModal;
